import { freddyTheme } from '@coolblue-development/freddy';
export const getStyleQuery = (useContainerQuery = false) => {
    const minWidth = (breakpoint) => {
        return useContainerQuery
            ? freddyTheme.breakpoint.containerQueryMinWidth(breakpoint)
            : freddyTheme.breakpoint.minWidth(breakpoint);
    };
    const maxWidth = (breakpoint) => {
        return useContainerQuery
            ? freddyTheme.breakpoint.containerQueryMaxWidth(breakpoint)
            : freddyTheme.breakpoint.maxWidth(breakpoint);
    };
    const only = (breakpoint) => {
        return useContainerQuery
            ? freddyTheme.breakpoint.containerQueryOnly(breakpoint)
            : freddyTheme.breakpoint.only(breakpoint);
    };
    const queryType = useContainerQuery ? 'container' : 'media';
    return { minWidth, maxWidth, only, queryType };
};
//# sourceMappingURL=getStyleQuery.js.map